import _ from 'lodash'
import moment from 'moment'
import accounting from 'accounting'
import { LoadingBar, Message } from 'iview'
import requestApi from './api'
import { codefansNetCC2PY } from '../utils/pinyin'

import { apiUrlHeader } from './api_url_header'

let apiHost = apiUrlHeader()

const mixin = {
  filters: {
    /**
     * 格式化货币
     * @param {number} value - 需要格式化的数值
     * @returns {string} 返回格式化后的货币，格式：￥3,456.62
     */
    currency: (value) => {
      if (_.isNaN(value)) {
        value = 0
      }
      value = accounting.formatMoney(value, '￥')
      return value
    },
    /**
     * 格式化日期时间
     * @param {string|number|Array|object} dateTime - 需要格式化的时间
     * @returns {string} 返回格式化后的日期时间，格式：2017年8月22日 11:22:33
     */
    datetime: (dateTime) => {
      if (!dateTime) {
        return ''
      }
      moment.locale('zh-CN')
      dateTime = moment(dateTime).format('YYYY年M月D日 HH:mm:ss')
      return dateTime
    },
    /**
     * 格式化日期
     * @param {string|number|Array|object} date - 需要格式化的时间
     * @returns {string} 返回格式化后的日期时间，格式：2017年8月22日
     */
    date: (date) => {
      if (!date) {
        return ''
      }
      moment.locale('zh-CN')
      date = moment(date).format('ll')
      return date
    },
    /**
     * 计算年龄
     * @param {string|number|Array|object} date - 需要计算的日期
     * @return {string} 返回计算后的年龄，如果大于36个月则显示“岁”（如：25岁），小与36个月显示月（如：25月），
     */
    age: (date) => {
      if (!date) {
        return ''
      }
      moment.locale('zh-CN')
      let ageValue = moment().diff(date, 'months')
      let ageUnit = '月'
      if (ageValue > 36) {
        ageValue = moment().diff(date, 'years')
        ageUnit = '岁'
      }
      const age = ageValue + ageUnit
      return age
    }
  },
  data () {
    return {
      apiHost,
      requestApi,
      maxPageSize: 2147483647,
      modalFluidStyles: {
        'min-width': '1349px',
        'width': '95%'
      }
    }
  },
  created () {
    Message.config({
      top: 50,
      duration: 3
    })
    LoadingBar.config({
      color: '#2196f3',
      failedColor: '#f44336',
      height: 3
    })
  },
  mounted () {
    // 如果有依赖dom必须存在的情况，就放到nextTick里面
    this.$nextTick(() => {
    })
  },
  methods: {
    /**
     * 格式化时间
     * @param {string|number|object|Array} dateTime - 时间，可以是一个字符串、时间戳、表示时间的对象、Date对象或者表示时间的数组
     * @param {string} [fmt] - 格式
     * @returns {string} 返回格式化后的日期时间，默认格式：2017年8月22日 11:22:33
     * @author 魏宏裕 <weihongyu@515cn.com>
     * @see [momentjs]{@tutorial http://momentjs.cn/}
     */
    formatDate (dateTime, fmt = 'lll') {
      if (!dateTime) {
        return ''
      }
      moment.locale('zh-cn')
      dateTime = moment(dateTime).format(fmt)
      return dateTime
    },
    /**
     * 格式化货币
     * @param {number} currency - 需要格式化的数值
     * @param {string} [symbol='￥'] - 货币符号
     * @param {number} [precision=2] - 小数位数
     * @param {string} [thousand=','] - 千分位
     * @param {string} [decimal='.'] - 小数点分隔符
     * @returns {string}
     * @author 魏宏裕 <weihongyu@515cn.com>
     * @see [accounting.js]{@tutorial http://openexchangerates.github.io/accounting.js/}
     */
    formatCurrency (currency, symbol = '￥', precision = 2, thousand = ',', decimal = '.') {
      if (_.isNaN(currency)) {
        currency = 0
      }
      currency = accounting.formatMoney(currency, symbol, precision, thousand, decimal)
      return currency
    },
    /**
     * 转换拼音缩写
     * @param {string} value - 需要转化的文字
     * @returns {string} 转换后的拼音缩写
     */
    pinyin (value) {
      return codefansNetCC2PY(value)
    },
    /**
     * 获取页面权限
     * @param {string} code - 页面的权限码
     * @returns {Array}
     */
    getElementCode (code) {
      const currentWorkList = JSON.parse(window.sessionStorage.getItem('work_list'))
      for (let workItem of currentWorkList) {
        if (workItem.name === code) {
          return workItem.element_codes
        }
      }
      return []
    },
    getInpatientDays (inpatientTime, leaveTime) {
      if (inpatientTime && leaveTime) {
        inpatientTime = this.formatDate(inpatientTime, 'YYYY-MM-DD HH:mm:ss')
        leaveTime = this.formatDate(leaveTime, 'YYYY-MM-DD HH:mm:ss')
        let inpatientTimeDate = inpatientTime.split(' ')[0] // 后面被转换成入院当天0点
        let leaveTimeDate = leaveTime.split(' ')[0] // 后面被转换成出院当天0点
        // 日历翻页就算1天,出院当天也算1天 eg. 2018-5-31 10:10:10 到 2018-6-1 0:0:0 要算 2 天
        return Math.abs(moment(inpatientTimeDate).diff(leaveTimeDate, 'days', true)) + 1 + ''
      } else {
        return '-'
      }
    }
  }
}

export default mixin
